import React, { useEffect, useState } from "react";
import adminService from "../../services/adminService";

// ✅ Backend base url (fallback 4000) — PAS 3000 (3000 = front)
const API_BASE = (process.env.REACT_APP_API_BASE_URL || "https://nouzhaback-theta.vercel.app").replace(/\/$/, "");

const pick = (obj, paths, fallback = null) => {
  for (const p of paths) {
    const v = p.split(".").reduce((acc, k) => (acc ? acc[k] : undefined), obj);
    if (v !== undefined && v !== null && v !== "") return v;
  }
  return fallback;
};

const AssignVoitureModal = ({ reservation, onClose, onAssigned }) => {
  const reservationId = reservation?._id;

  const [voitures, setVoitures] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedVoitureId, setSelectedVoitureId] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);

        // 1) Essayer via admin models (si tu as "voitures" géré dans /admin)
        try {
          const resAdmin = await adminService.getAllItems("voitures", {
            page: 1,
            limit: 500,
            search: "",
          });

          const list = resAdmin?.data?.items || [];
          if (Array.isArray(list) && list.length) {
            setVoitures(list);
            return;
          }
        } catch (eAdmin) {
          console.warn(
            "adminService.getAllItems(voitures) failed, fallback API:",
            eAdmin?.message || eAdmin
          );
        }

        // 2) fallback API public
        const resp = await fetch(`${API_BASE}/api/voitures`);
        const data = await resp.json();

        // tolérant : data.data || data.items || data
        const list = data?.data || data?.items || data || [];
        setVoitures(Array.isArray(list) ? list : []);
      } catch (e) {
        console.error(e);
        setVoitures([]);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [reservationId]);

  const assign = async () => {
    if (!selectedVoitureId) return alert("Sélectionne une voiture");

    try {
      await adminService.assignVoitureToReservation(reservationId, selectedVoitureId);
      alert("Voiture assignée ✅");
      await onAssigned?.();
    } catch (e) {
      console.error(e);
      alert(e?.message || "Erreur lors de l'assignation");
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[85] flex items-center justify-center p-4 pt-20 overflow-y-auto">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl overflow-hidden">
        <div className="bg-gradient-to-r from-orange-500 to-red-600 text-white px-6 py-4">
          <div className="flex justify-between items-center">
            <div>
              <h3 className="text-lg font-bold">Assigner une voiture</h3>
              <p className="text-xs text-white/90">Réservation ID: {reservationId || "—"}</p>
            </div>
            <button onClick={onClose} className="text-white hover:text-slate-200">
              ✖
            </button>
          </div>
        </div>

        <div className="p-6 max-h-[70vh] overflow-y-auto">
          {loading ? (
            <div className="p-6 text-center text-slate-600">Chargement des voitures...</div>
          ) : voitures.length === 0 ? (
            <div className="p-6 text-center text-slate-600">Aucune voiture disponible.</div>
          ) : (
            <div className="space-y-3">
              {voitures.map((v) => {
                const marque = pick(v, ["marque"], "—");
                const modele = pick(v, ["modele"], "—");
                const ville = pick(v, ["ville"], "—");
                const prixJour = pick(v, ["prix_jour"], "—");
                const image = pick(v, ["image"], "");

                return (
                  <label
                    key={v._id}
                    className={`flex items-center gap-4 p-4 rounded-xl border cursor-pointer transition ${selectedVoitureId === v._id
                        ? "border-orange-500 bg-orange-50"
                        : "border-slate-200 hover:bg-slate-50"
                      }`}
                  >
                    <input
                      type="radio"
                      name="voiture"
                      checked={selectedVoitureId === v._id}
                      onChange={() => setSelectedVoitureId(v._id)}
                      className="h-4 w-4 accent-orange-600"
                    />

                    <div className="flex-1">
                      <div className="font-bold text-slate-900">
                        {marque} {modele}
                      </div>
                      <div className="text-sm text-slate-600">
                        {ville} • {prixJour !== "—" ? `${prixJour} MAD/jour` : "prix —"}
                      </div>
                      <div className="text-xs text-slate-500 mt-1">ID: {v._id}</div>
                    </div>

                    {image && (
                      <img
                        src={image.startsWith("http") ? image : `${API_BASE}${image}`}
                        alt="voiture"
                        className="w-24 h-16 object-cover rounded-lg border border-slate-200"
                        onError={(e) => (e.currentTarget.style.display = "none")}
                      />
                    )}
                  </label>
                );
              })}
            </div>
          )}
        </div>

        <div className="bg-slate-50 px-6 py-4 flex flex-col sm:flex-row gap-3 justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-slate-300 rounded-lg text-slate-700 hover:bg-slate-100 transition-colors"
          >
            Fermer
          </button>
          <button
            onClick={assign}
            disabled={!selectedVoitureId}
            className="px-5 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors disabled:opacity-50"
          >
            ✅ Assigner cette voiture
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignVoitureModal;
